import { Address, LineItem } from "../../order-tracking/types";

export interface DateRangeParams {
  startDate: string;
  endDate: string;
  status?: statusOrder[];
}

export enum statusOrder{
  VERIFIED = 'verified',
  PENDING = 'pending',
}

export interface Order {
  id: number;
  shopifyOrderId: string;
  orderNumber: string;
  totalPrice: string;
  currency: string;
  financialStatus: string;
  fulfillmentStatus?: string;
  customerEmail?: string;
  customerPhone?: string;
  shippingAddress?: Address;
  billingAddress?: Address;
  lineItems?: LineItem[];
  rawData?: Record<string, unknown>;
  processedAt?: Date;
  status: string;
  csf?: string;
  cfdiUse?: string;
  rfc?: string;
  paymentMethod?: string;
  taxRegime?: string;
  fullName?: string;
  zipCode?: number;
  state?: string;
  neighborhood?: string;
  street?: string;
  number?: string;
  cmpNumber?: string;
  district?: string;
  region?: string;
  createdAt: Date;
  updatedAt: Date;
  expirationDate?: Date;
} 
